export default __webpack_public_path__ + "static/media/puzzle-pieces.b3969191.svg";